package studio.goodegg.capsule.utils

sealed class Response<out T>

data class Success<out T>(val data: T) : Response<T>()

data class Failed(val error: Throwable) : Response<Nothing>()
